module.exports = __webpack_public_path__ + "static/media/roller-shutter-spraying-001.cf209a76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/roller-shutter-spraying-001.jpg
// module id = 95
// module chunks = 0